import React from 'react'

import { Box, Typography } from '@forgeglobal/design-framework'

interface ErrorBoundaryProps {
  children: React.ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)

    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    const { children } = this.props
    const { hasError } = this.state

    if (hasError)
      return (
        <Box p={4}>
          <Typography>Something went wrong. Please try refreshing the page.</Typography>
        </Box>
      )

    return children
  }
}

export default ErrorBoundary
